module.exports = __webpack_public_path__ + "img/burger_menu_color.1a46065c.svg";